import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToTopInstant } from '../utils/scrollUtils';

/**
 * Component that scrolls to top of page on route change
 * Should be placed inside Router but outside Routes
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top instantly when route changes
    scrollToTopInstant();
  }, [pathname]);

  return null;
}






